
<!--
Credits to:
https://medium.com/js-dojo/how-to-create-an-animated-countdown-timer-with-vue-89738903823f
-->
<template>
  <div class="d-flex justify-content-center">
    <div class="position-relative base-timer">
      <div class="position-absolute d-flex justify-content-center align-items-center progress-time-container">
        <div class="">
          <div class="text-gray-most-darken timer-text " mt="1">
            <vue-time-string :time="currentTime"></vue-time-string>
          </div>
          <div mt="1" class="d-flex justify-content-center align-items-center">
            <span v-if="isPaused || isStopped" class="timer-actions" mr="0.5" ml="0.5" @click="play()" :title="$t('play')"><i class="bi bi-play-fill"></i></span>
            <span v-if="isPlayed" class="timer-actions" mr="0.5" ml="0.5" @click="pause()" :title="$t('pause')"><i class="bi bi-pause-fill"></i></span>
            <span v-if="isPlayed || isPaused" class="timer-actions" mr="0.5" ml="0.5" @click="finish()" :title="$t('finish')"><i class="bi bi-check2"></i></span>
            <span v-if="isTimeUp" class="timer-actions" mr="0.5" ml="0.5" @click="restart()" :title="$t('restart')"><i class="bi bi-arrow-counterclockwise"></i></span>
          </div>
        </div>
      </div>
      <svg
        class="base-timer__svg"
        viewBox="0 0 120 120"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g class="base-timer__circle">
          <circle
            class="base-timer__path-elapsed"
            cx="60"
            cy="60"
            r="45"
          />
          <path
            :stroke-dasharray="timeStroke"
            class="base-timer__path-remaining"
            v-if="!isTimeUp"
            :style="{'transition-duration': strokeTransitionDuration}"
            d="
              M 60, 60
              m -45, 0
              a 45,45 0 1,0 90,0
              a 45,45 0 1,0 -90,0
            "></path>
        </g>
      </svg>
      <div class="d-flex justify-content-center">
        <div mr="0.5">
          <span><i class="bi bi-clock"></i></span>
          <span>{{ formattedCountExec }}</span>
        </div>
        <div ml="0.5">
          <span><i class="bi bi-alarm"></i></span>
          <span><vue-time-string :time="taskData.time_exec"></vue-time-string></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /*
  STATUSES:
  0 - STOPPED
  1 - PLAYED
  2 - PAUSED
  3 - TIMESUP
  */
  import { mapActions } from 'vuex';

  export default{
    data: function(){
      return {
        countTime: null,
        timeInterval: null,
        status: 0,
      }
    },
    props: {
      time: Number,
      timePart: {
        type: Number,
        default: 1
      },
      taskData: Object
    },
    methods: {
      ...mapActions('taskStoreModule', ['playTask', 'pauseTask', 'stopTask', 'timesUpTask', 'finishTask']),
      play(){
        this.playTask({task_id: this.taskData["id"]})
      },
      pause(){
        this.pauseTask({task_id: this.taskData["id"]});
      },
      stop(){
        this.stopTask({task_id: this.taskData["id"]});
      },
      timesUp(){
        this.timesUpTask({task_id: this.taskData["id"], renderId: this.taskData["renderId"]});
      },
      restart(){
        this.stopTask({task_id: this.taskData["id"]});
      },
      finish(){
        this.finishTask({task_id: this.taskData["id"], elapsedTime: this.elapsedTime})
      },
      triggerPlay(){
        const intervalHandler = () =>{
          if(this.countTime>0){
            this.countTime--;
          }else{
            clearInterval(this.timeInterval);
            this.timesUp();
          }
        }
        this.timeInterval = setInterval(intervalHandler, 1000/this.timePart)
      },
      triggerPause(){
        clearInterval(this.timeInterval)
      },
      triggerStop(){
        clearInterval(this.timeInterval);
        this.countTime = this.time*this.timePart;
      }
    },
    computed: {
      formattedMinutes: function(){
        let minutes = Math.trunc((this.countTime/this.timePart)/60)
        return minutes.toString().padStart(2, '0');
      },
      formattedSeconds: function(){
        let seconds = Math.trunc(this.countTime/this.timePart)%60
        return seconds.toString().padStart(2, '0');
      },
      timeStroke: function(){
        let factor = this.countTime/(this.time*this.timePart)
        let strokeProportion = Math.round(283*factor)
        return `${strokeProportion} 283`
      },
      currentTime: function(){
        return Math.trunc((this.countTime/this.timePart));
      },
      elapsedTime: function(){
        return this.time-this.currentTime;
      },
      strokeTransitionDuration: function(){
        return `${1/this.timePart}s`
      },
      formattedCountExec: function(){
        return this.taskData["count_exec"].toString().padStart(2, '0');
      },
      timerState: function(){
        return this.taskData["timerState"];
      },
      isTimeUp(){
        return this.timerState==3;
      },
      isStopped(){
        return this.timerState==0;
      },
      isPlayed(){
        return this.timerState==1;
      },
      isPaused(){
        return this.timerState==2;
      }
    },
    watch: {
      timerState: function(newValue, oldValue){
        switch(newValue){
          case 0:
            this.triggerStop();
            break;
          case 1:
            this.triggerPlay();
            break;
          case 2:
            this.triggerPause();
            break;
        }
      }
    },
    beforeMount(){
      this.countTime = this.time*this.timePart;
    },
    i18n: {
      messages: {
        "pt-BR": {
          pause: 'Pausar',
          restart: 'Reiniciar',
          stop: 'Parar',
          play: 'Iniciar',
          finish: 'Finalizar'
        },
        en: {
          pause: 'Pause',
          restart: 'Restart',
          stop: 'Stop',
          play: 'Play',
          finish: 'Finish'
        }
      }
    }
  }
</script>
